import React from 'react';
import { Skeleton } from '@mui/material';

function TableSkeleton(props) {
  const { qty } = props;

  return (
    <tr>
      {Array.from({ length: qty }, (v, k) => k).map((_, idx) => (
        // eslint-disable-next-line react/no-array-index-key
        <td key={idx}>
          <Skeleton />
        </td>
      ))}
    </tr>
  );
}

export default TableSkeleton;
